/**
 * Shops accordion + photo/map panel. Hovering or clicking a shop opens it; the Google Maps iframe
 * is created only when the visitor switches to "Mappa" (no third-party cookie before that).
 */
class PoianaStores extends HTMLElement {
  connectedCallback() {
    this.stores = [...this.querySelectorAll('[data-store]')];
    this.photos = [...this.querySelectorAll('[data-store-photo]')];
    this.index = 0;
    this.mapOn = false;

    this.stores.forEach((store, index) => {
      const head = store.querySelector('.store__head');
      head.addEventListener('click', () => this.select(index));
      head.addEventListener('mouseenter', () => this.select(index));
    });

    this.querySelectorAll('[data-stores-view]').forEach((button) => {
      button.addEventListener('click', () => this.view(button.dataset.storesView));
    });
  }

  select(index) {
    if (index === this.index) return;
    this.index = index;

    this.stores.forEach((store, i) => {
      const open = i === index;
      store.classList.toggle('is-active', open);
      store.querySelector('.store__head').setAttribute('aria-expanded', String(open));
      store.querySelector('.store__body').hidden = !open;
    });
    this.photos.forEach((photo, i) => photo.classList.toggle('is-active', i === index));

    const store = this.stores[index];
    this.querySelector('[data-store-kicker]').textContent = store.dataset.name;
    this.querySelector('[data-store-town]').textContent = store.dataset.town;
    if (this.mapOn) this.loadMap();
  }

  view(kind) {
    this.mapOn = kind === 'map';
    this.querySelectorAll('[data-stores-view]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.storesView === kind));
    });
    this.querySelector('[data-stores-photos]').hidden = this.mapOn;
    this.querySelector('[data-stores-map]').hidden = !this.mapOn;
    if (this.mapOn) this.loadMap();
  }

  loadMap() {
    const store = this.stores[this.index];
    const box = this.querySelector('[data-stores-map]');
    let frame = box.querySelector('iframe');
    if (!frame) {
      frame = document.createElement('iframe');
      frame.loading = 'lazy';
      frame.referrerPolicy = 'no-referrer-when-downgrade';
      box.append(frame);
    }
    frame.title = this.dataset.mapTitle.replace('%town%', store.dataset.town);
    frame.src = `https://maps.google.com/maps?q=${encodeURIComponent(store.dataset.query)}&z=15&output=embed`;
  }
}

if (!customElements.get('poiana-stores')) customElements.define('poiana-stores', PoianaStores);
